import { useSelector } from "react-redux";
import { Box, Checkbox, Flex, HStack, Text, VStack } from "@chakra-ui/react";

import SmeProfileIcon from "../../components/Icons/SmeProfileIcon";
import CompanyDetailsIcon from "../../components/Icons/CompanyDetailsIcon";
import UploadStatementsIcon from "../../components/Icons/UploadStatementsIcon";
import ViewBalanceIcon from "../../components/Icons/ViewBalanceIcon";
import { CLIENT_BACKGROUND_TABS, PRODUCTS_TABS } from "../../constants/ui";
import FindSuppliers from "./FindSuppliers";
import ProductsInnerLayout from "./ProductsInnerLayout";
import { useState } from "react";
import CategorySize from "./CategorySize";
// import IndustryActivity from "../Agency/IndustryActivity";

const ClientBackgroundLinks = ({ currentTab, changeTab }) => {
  return (
    <Box>
      <Box style={{ fontSize: "17px", fontWeight: "400" }}>Filter</Box>
      <Box m={"0px"} w={"100%"}>
        <Checkbox>
          <span style={{ fontSize: "14px" }}>Alkalies and chlorine</span>
        </Checkbox>
      </Box>
      <Box m={"0px"} w={"100%"}>
        <Checkbox>
          <span style={{ fontSize: "14px" }}>Inorganic Pigments</span>
        </Checkbox>
      </Box>
    </Box>
  );
};

const TabContent = ({ tab, clientData }) => {
  switch (tab) {
    // case CLIENT_BACKGROUND_TABS.SME_PROFILE:
    //   return <SMEProfile clientData={clientData} />;
    // case PRODUCTS_TABS.SME_ACTIVITY:
    //   return <IndustryActivity clientData={clientData} />;
    case PRODUCTS_TABS.CATEGORY_SIZE:
      return <CategorySize clientData={clientData} />;
    case PRODUCTS_TABS.FIND_SUPPLIERS:
      return (
        <>
          <Flex>
            <Box
              w="100%"
              h="calc(100% - var(--headerbar-height) - var(--footerbar-height))"
              padding={"10px"}
            >
              <Box margin="0px" className="SMEBackgroundBoxShadow">
                <HStack
                  w={"100%"}
                  spacing={4}
                  alignItems={"start"}
                  className="shadowBox"
                >
                  <Box w={"200px!important"}>
                    <VStack
                      // w={'70%'}
                      spacing={4}
                      m={1}
                      className="leftNavOptions"
                      alignItems={"center"}
                      p="10px 3px"
                    >
                      <Box>
                        <Box
                          style={{
                            fontSize: "14px",
                            fontWeight: "bold",
                            marginBottom: "12px",
                          }}
                        >
                          Filter
                        </Box>
                        <Box m={"0px"} w={"100%"}>
                          <Checkbox>
                            <span style={{ fontSize: "14px" }}>
                              Alkalies and chlorine
                            </span>
                          </Checkbox>
                        </Box>
                        <Box m={"0px"} w={"100%"}>
                          <Checkbox>
                            <span style={{ fontSize: "14px" }}>
                              Inorganic Pigments
                            </span>
                          </Checkbox>
                        </Box>
                      </Box>
                    </VStack>
                  </Box>
                  <Box mt={2} w={"80%"}>
                    <FindSuppliers clientData={clientData} />
                  </Box>
                </HStack>
              </Box>
            </Box>
          </Flex>
        </>
      );
  }
};

const ProductDetails = () => {
  const { client } = useSelector((state) => state.clientReducer);

  const [currentTab, setCurrentTab] = useState(PRODUCTS_TABS.CATEGORY_SIZE);

  const changeTab = (newTab) => {
    setCurrentTab(newTab);
  };

  console.log("=====currentTab", currentTab);
  return (
    <>
      <ProductsInnerLayout currentTab={currentTab} changeTab={changeTab} />
      {!client?.details?.loading && (
        <TabContent tab={currentTab} clientData={client?.details?.data} />
      )}
    </>
  );
};

export default ProductDetails;
